import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "App";
import "./index.css";

import { MaterialUIControllerProvider } from "context";
import { AuthServiceProvider } from "./context/auth";

const container = document.getElementById("app");
const root = createRoot(container);

root.render(
  <BrowserRouter>
    <MaterialUIControllerProvider>
      <AuthServiceProvider>
        <App />
      </AuthServiceProvider>
    </MaterialUIControllerProvider>
  </BrowserRouter>
);
